import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { Subscription } from 'rxjs';

@Injectable()
export class HeaderNsideService {

  constructor(private http: HttpClient) { }

invokeFirstComponentFunction = new EventEmitter();
subsVar: Subscription;
invokeAutoAdjust= new EventEmitter();
contentHeight: Subscription;
invokeAutoAdjustapp= new EventEmitter();
contentHeightapp: Subscription;


invokeFirstComponentFunctionSidebarSA = new EventEmitter();
  subsVarSASidebar: Subscription;

  onSidebarClickedMobileViewSA(){
    this.invokeFirstComponentFunctionSidebarSA.emit();
  }

  onFirstComponentButtonClick() {
    this.invokeFirstComponentFunction.emit();
  }

   getSideBarData(){
     return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/sidebar');
  }

  removeNotification(delNots: any[]) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/removeSaNotifications?notificationIds='+ delNots);
  }

  getHeaderData() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/header');
  }

  uploadAdminPhoto(file: File) {
    const data: FormData = new FormData();
    data.append("photo", file);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append( 'Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Dashboard/uploadPhoto', data, { headers, reportProgress: true, observe:'events' });
  }

  changePassword(oldPwd: string, newPwd: string, rePwd: string) {
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/changePassword?oldPwd=' + oldPwd + '&newPwd=' + newPwd + '&rePwd='+rePwd);
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Dashboard/changePassword', {oldPwd: oldPwd, newPwd:newPwd, rePwd: rePwd})
  }

  roleMatch(allowedRole): boolean {
    let isMatch = false;
    let userRole: string = JSON.parse(localStorage.getItem('userRole'));
    if (userRole.indexOf(allowedRole) > -1) {
      isMatch = true;
      return false;
    }
    return isMatch;
  }

  getNotifications() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/getNotifications');
  }

  getSaLogs(pageNo: number, text: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/ActionHistory/getSaLogs?pageNo='+pageNo+'&text='+text );
  }


  }
